import MobileWidgetGradientCardsIcon
    from '../../../../../mobileAppCore/components/MobileWidgets/MobileWidgetGradientCardsIcon/MobileWidgetGradientCardsIcon';
import { COLLECTION_KEYS } from '../../../../../mobileAppCore/components/MobileMarket/mobileMarketConstants';
import React from 'react';
import { LiteTradePortfolioLastViewedStyled } from './styled/LiteTradePortfolioLastViewedStyled';

function LiteTradePortfolioLastViewed() {
    return <LiteTradePortfolioLastViewedStyled>
        <MobileWidgetGradientCardsIcon collectionKey={COLLECTION_KEYS.LAST_VIEWED}/>
    </LiteTradePortfolioLastViewedStyled>;
}

export default LiteTradePortfolioLastViewed;
